// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__X1t6f","main-content":"Layout_main-content__4LMDs","nav-hide":"Layout_nav-hide__LH5E7"};